export enum PromoApplicability {
    CURRENT_ORDER = 'current_order',
    NEXT_ORDER = 'next_order'
}
